module.exports = __webpack_public_path__ + "img/logobank.27cccb07.png";